import { Component } from '@angular/core';
import { OERIService } from '../../../../services/oeri.service';
import { TableModule } from 'primeng/table';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CommonModule, NgIf } from '@angular/common';
import { DropdownModule } from 'primeng/dropdown';
import { CommonService } from '../../../../services/common.service';
import { FormsModule, NgModel } from '@angular/forms';
import { ReportsService } from '../../../../services/reports.service';
import saveAs from 'file-saver';
import { filter, Subscription } from 'rxjs';
import { NotificationService } from '../../../../services/notification.service';

@Component({
    selector: 'app-discovered-past-reports',
    imports: [TableModule, NgIf, DropdownModule, CommonModule, FormsModule],
    templateUrl: './discovered-past-reports.component.html',
    styleUrl: './discovered-past-reports.component.scss'
})
export class DiscoveredPastReportsComponent {
  isShowMainBlock: boolean = false;
  divisionList =[]
  sectionsList =[]
  plantList  = []
  reportData: any = [];
  isLoading: boolean = false;
  oeriStatistics: any = {
    lastCalled: '',
    openTlr : 0,
    removedIn30days : 0
  };
    
  paramSub: Subscription | undefined;
  
  constructor(
    private oeriService: OERIService,
    private notificationService:NotificationService,
    private report: ReportsService,
    private router:Router,
    public commonService : CommonService,
    private route: ActivatedRoute,
    
  ) { 

  }

  ngOnInit(){
    this.isLoading = true;
    this.getOERIStatistics();
    this.getDivisionList();
    this.route.queryParams.subscribe((params: any) => {
      if (Object.keys(params).length) {
        this.filters = {...params};
        this.isShowMainBlock = true;
        this.getDiscoveredPastReports();
      } else {
        this.isShowMainBlock = false;
      }
    });

  }

  ngOnDestroy() {
    if (this.paramSub) {
      this.paramSub.unsubscribe();
    }
  }
  getOERIStatistics(){
    this.oeriService.getOeriStatistics().subscribe((response: any) => {
      this.oeriStatistics.lastCalled = this.commonService.formatDateTime(response.oeriLastCalledTLR);
      this.oeriStatistics.openTlr = response.openTLRsToOERI;
      this.oeriStatistics.removedIn30days = response.removedTLRsLast30DaysToOERI;

    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }
  getDivisionList() {
    this.report.getLDAREmissionbuildSearch('ES',true).subscribe(
      (data: any) => {
        this.divisionList = data.divisionItems//?.map((items: { value: any; }) => items.value);
        this.sectionsList = data.sectionItems//?.map((items: { value: any; }) => items.value);
        this.plantList = data.plantItems//?.map((items: { value: any; }) => items.value);
      },
      (error: any) => {
        console.error('Error fetching air compliance details', error);
      }
    );
  }
  filters = {
    division: 'ALL',
    section: 'ALL',
    plant: 'ALL',
  }
  runReport(){

      this.router.navigate([], {
      relativeTo: this.route,
      queryParams: {
        division: this.filters.division ,
        section: this.filters.section,
        plant: this.filters.plant,
      },
      queryParamsHandling: 'merge',
    });
 
  }

  getDiscoveredPastReports() {
    let params = {
      division: this.filters.division,
      section: this.filters.section,
      plant: this.filters.plant,
      facilityId: localStorage.getItem('current_facility_id'),

    };
    
    this.oeriService.getDiscoveredPastReports(params).subscribe((response: any) => {
      this.reportData = response || [];
      this.isShowMainBlock = true;
    }, (error: any) => {
      console.error('Error fetching OERI data:', error);
    });
  }

  details(row: any){
    this.router.navigate(['/details-section', row.Tag_Number]);
  }

  exportToExcel() {
    
    this.isLoading = true;
    this.oeriService.getDiscoveredPastReportsExcel(this.filters)
        .subscribe({
            next: (fileData: any) => {
                if (fileData) {
                    saveAs(fileData, 'TLR-OERIPast60Days.xlsx');
                }
                this.notificationService.showSuccess("file downloaded successfully");
            this.isLoading = false;
            },
            error: (err: any) => {
                console.error('Error fetching report details:', err);
                this.isLoading = false;

            }
        });
}


  backBtn(){
    this.router.navigate(['/discovered-past-reports']);
  }
}
